function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm0 16.839c-4.306 0-7.839-3.486-7.839-7.839 0-4.306 3.486-7.839 7.839-7.839 4.306 0 7.839 3.486 7.839 7.839 0 4.306-3.486 7.839-7.839 7.839zm5.14-9.979l-6.55 6.497a.435.435 0 0 1-.616-.002l-3.116-3.142a.435.435 0 0 1 .002-.616l.31-.306a.435.435 0 0 1 .615.002l2.503 2.524 5.932-5.884a.435.435 0 0 1 .616.002l.306.31c.17.17.169.446-.002.615z"
});

var SvgCheckCircleInline = function SvgCheckCircleInline(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default SvgCheckCircleInline;